import React from 'react'
import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material'
import { suffixOptions } from 'utils'

interface SuffixSelectProps {
  value: number | null
  onChange: (event: SelectChangeEvent<number>, child: React.ReactNode) => void
  disabled?: boolean
}

export const SuffixSelect: React.FC<SuffixSelectProps> = ({ value, onChange, disabled = false }) => {
  const displayValue = value === 0 ? '' : value

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="suffix_id_label">Suffix</InputLabel>
      <Select
        id="suffix_id"
        name="suffixId"
        label="Suffix"
        labelId="suffix_id_label"
        value={displayValue ?? ''}
        onChange={onChange}
        disabled={disabled}
      >
        {suffixOptions.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.id === 0 ? <em>None</em> : option.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
